// extracted by mini-css-extract-plugin
export default {"container":"lvXwAYvs1zWqqDNWdu5w"};